// extracted by mini-css-extract-plugin
export default {"title":"L--z","warning":"M--z","sizeOptionsLegendText":"N--z"};